var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFieldSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136,
    height: 95,
    viewBox: "0 0 136 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_114",
    x: 0,
    y: 0,
    width: 136,
    height: 95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    "data-name": "Grupo 55",
    transform: "translate(-578 -199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(138 103.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(-252 -300.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 692, 396)",
    filter: "url(#Rect\\xE1ngulo_114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_114-2",
    "data-name": "Rect\\xE1ngulo 114",
    transform: "translate(9 9)",
    fill: "#9976b7",
    stroke: "#314164",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 77,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 76,
    rx: 6.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M0,0V75.75",
    transform: "translate(760.5 405.5)",
    fill: "#9976b7",
    stroke: "#314164",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_35",
    "data-name": "L\\xEDnea 35",
    y2: 75.75,
    transform: "translate(716 405.5)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_36",
    "data-name": "L\\xEDnea 36",
    y2: 75.75,
    transform: "translate(804 405.5)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_37",
    "data-name": "L\\xEDnea 37",
    x2: 88,
    transform: "translate(716 443.25)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldSelected);
export default __webpack_public_path__ + "static/media/field-selected.151da36f30a7605cd04c3f550544e257.svg";
export { ForwardRef as ReactComponent };